module.exports = __webpack_public_path__ + "static/media/sunset.bbe57d52.jpg";